import userViewGuard from "~/hooks/useViewPermssionsCheck";
import {
	useStaffMembersBenefitsReport,
} from "~/modules/humanResources/api/staffMemberBenefit/staffMemberBenefitQueries.ts";
import StaffBenefitsReportView from "~/modules/humanResources/components/StaffBenefitsReportView/StaffBenefitsReportView";
import { PermissionNames } from "~/types/entityNames.ts";

const StaffBenefitsReportPage = () => {
	const guard = userViewGuard(PermissionNames.CanManagesStaffSalaries);
	if (guard) return guard;

	const {
		data: benefitsReportResponseData,
		isLoading: benefitsReportIsLoading,
	} = useStaffMembersBenefitsReport();



	return <StaffBenefitsReportView isLoading={benefitsReportIsLoading}
									benefitsReportResponseData={benefitsReportResponseData}
	/>;
};

export default StaffBenefitsReportPage;